import { createEmptyContext } from '../../../utils/create-empty-context';
/**
 * Quick Navigator context will wrap all children components and be available as merged props.
 */
export const QuickNavigatorContextInstance = createEmptyContext();
/**
 * Utility method to create `QuickNavigatorContext` object from `QuickNavigatorProps`.
 * @param props
 * @param state
 * @param dispatch
 */
export function mapQuickNavigatorContext(props, state, dispatch) {
    const { displayText, assets, config, events, cdnOptions } = props;
    return {
        displayText,
        assets,
        config,
        events,
        cdnOptions,
        state,
        dispatch
    };
}
//# sourceMappingURL=context.js.map